import React from "react";

// A cluster of SHORT fields rendered inline and wrapped, instead of one
// full-height "label left / value right" row per field.
//
// Standing project requirement, not a per-screen choice: "use a single block
// to show all details and save some height... so more records fit in a single
// screen (to be noted as project requirement for all list screens)". Four
// stacked rows cost ~100px; the same four fields cost one or two lines here.
//
// Only short fields belong inside it. Long free text - a complaint
// description, remarks, a technician's comment - stays on its own line
// underneath, where it can breathe.
export const CompactInfoField = ({ label, value, icon: Icon }) => {
  if (value == null || value === "") return null;
  return (
    <span className="d-inline-flex align-items-center me-4 mb-1" style={{ fontSize: 13 }}>
      {Icon && <Icon size={13} className="text-muted me-1 flex-shrink-0" />}
      <span className="text-muted me-1">{label}</span>
      <span className="fw-semibold">{value}</span>
    </span>
  );
};

const CompactInfoBlock = ({ children, className = "" }) => (
  <div className={`d-flex flex-wrap ${className}`}>{children}</div>
);

export default CompactInfoBlock;
